import{ imageDomain} from "../configC/keys"
export const content = [
  {
    title: "Sale & Purchase",
    description:
      "We make property buying, selling process easy, simple, and transparent for you. We have got great real estate deals for you.",
      description2:"We are most preferred and reliable property consultants in Dwarka(Delhi) and Dwarka Expressway(Gurugram)",
      button: "Contact Us",
    image: `${imageDomain}/upload/banner/wb1.jpg`,
    // user: "Luan Gjokaj",
    // userProfile: "https://i.imgur.com/JSW6mEk.png" 
  },
  {
    title: "Rentals & Leasing",
    description:
      "We take care of all the work starting from finding the best option to completing the documentation & formalities and handing over the keys.",
      description2:"Ethical business practices, honest and transparent services.",
      
      button: "Contact Us",
    image: `${imageDomain}/upload/banner/wb2.jpeg`,
    // user: "Erich Behrens",
    // userProfile: "https://i.imgur.com/0Clfnu7.png"
  },
  {
    title: "One Stop Solution",
    description:
      "We provide all real estate related services such as Documentation, Bank Loan, TDS /Tax Compliances, Registration of Property, Interiors, Vastu,etc.",
      description2:"We are one of the oldest real estate company in Dwarka and Dwarka Expressway and have served Thousands of customers.",
      
      button: "Contact Us",
    image: `${imageDomain}/upload/banner/wb3.jpg`,
    // user: "Bruno Vizovskyy",
    // userProfile: "https://i.imgur.com/4KeKvtH.png"
  },
  {
    title: "Services for NRI",
    description:
      "A person sitting overseas thinking of selling or buying have been made easy. We can guide them of completing the entire process flawlessly by advising at each step when its needed whether its Taxation, documentation, Registration or anything, we are THERE.",
      description2:"Have completed more then 200+ transactions involving NRIs.",
      
      button: "Contact Us",
    image: `${imageDomain}/upload/banner/wb4.jpeg`,
    // user: "Bruno Vizovskyy",
    // userProfile: "https://i.imgur.com/4KeKvtH.png"
  },
  {
    title: "Interiors",
    description:
      "When it comes to building your dream home, we provide you the best of designs and implementation. We have 130+ happy clients for whom we have worked.",
      button: "Contact Us",
      description2:"Unmatched & Budget Friendly Prices",
    image: `${imageDomain}/upload/banner/wb5.jpeg`,
    // user: "Bruno Vizovskyy",
    // userProfile: "https://i.imgur.com/4KeKvtH.png"
  },
  {
    title: "Loans Made Easy",
    description:
      "We are associated with multiple Public / Private Sector banks such as SBI, Bank of Baroda, HDFC, ICICI, Axis, etc for your finance needs and get all the work done from your door step.",
      description2:"We provide Attractive Home Loan Rates and offers",
      
      button: "Contact Us",
    image: `${imageDomain}/upload/banner/wb6.jpg`,
    // user: "Bruno Vizovskyy",
    // userProfile: "https://i.imgur.com/4KeKvtH.png"
  }
  
];

 export const data= [
  'http://192.168.2.131:9001/public/files/wb1.jpg',
  'http://192.168.2.131:9001/public/files/wb2.jpg',
  'http://192.168.2.131:9001/public/files/v1.jpeg'  ,
  'http://192.168.2.131:9001/public/files/v2.jpeg',
  'http://192.168.2.131:9001/public/files/v3.jpeg',
  'http://192.168.2.131:9001/public/files/v4.jpeg',
  'http://192.168.2.131:9001/public/files/v5.jpeg',
  'http://192.168.2.131:9001/public/files/view (5).jpeg',
  'http://192.168.2.131:9001/public/files/view (6).jpeg',
  'http://192.168.2.131:9001/public/files/view (7).jpeg',
  'http://192.168.2.131:9001/public/files/view (8).jpeg',
  'http://192.168.2.131:9001/public/files/view (9).jpeg',
  'http://192.168.2.131:9001/public/files/view (10).jpeg',
  'http://192.168.2.131:9001/public/files/view (11).jpeg',
  'http://192.168.2.131:9001/public/files/view (12).jpeg',
  'http://192.168.2.131:9001/public/files/view (13).jpeg',
  'http://192.168.2.131:9001/public/files/view (14).jpeg',
  'http://192.168.2.131:9001/public/files/view (15).jpeg',
  'http://192.168.2.131:9001/public/files/view (16).jpeg',
  'http://192.168.2.131:9001/public/files/view (17).jpeg',
  'http://192.168.2.131:9001/public/files/view (18).jpeg',
  'http://192.168.2.131:9001/public/files/view (19).jpeg',
  'http://192.168.2.131:9001/public/files/view (20).jpeg',
  'http://192.168.2.131:9001/public/files/view (21).jpeg',
  'http://192.168.2.131:9001/public/files/view (22).jpeg',
  'http://192.168.2.131:9001/public/files/view (23).jpeg',
  'http://192.168.2.131:9001/public/files/view (24).jpeg',
  'http://192.168.2.131:9001/public/files/view (25).jpeg',
  'http://192.168.2.131:9001/public/files/view (26).jpeg',
  'http://192.168.2.131:9001/public/files/view (27).jpeg',
  'http://192.168.2.131:9001/public/files/view (28).jpeg',
  'http://192.168.2.131:9001/public/files/view (29).jpeg',
  'http://192.168.2.131:9001/public/files/view (30).jpeg',
  'http://192.168.2.131:9001/public/files/view (31).jpeg',
  'http://192.168.2.131:9001/public/files/view (32).jpeg',
  'http://192.168.2.131:9001/public/files/view (33).jpeg'  ,
  'http://192.168.2.131:9001/public/files/view (34).jpeg'  ,
  'http://192.168.2.131:9001/public/files/view (35).jpeg'  ,
  'http://192.168.2.131:9001/public/files/view (36).jpeg'  ,
  'http://192.168.2.131:9001/public/files/view (37).jpeg'  ,
  'http://192.168.2.131:9001/public/files/view (38).jpeg'  ,
  'http://192.168.2.131:9001/public/files/view (39).jpeg'  ,
  'http://192.168.2.131:9001/public/files/view (40).jpeg'  ,
  'http://192.168.2.131:9001/public/files/view (41).jpeg'  ,
  'http://192.168.2.131:9001/public/files/view (42).jpeg'  ,
  'http://192.168.2.131:9001/public/files/view (43).jpeg'  ,
  'http://192.168.2.131:9001/public/files/view (44).jpeg'  ,
  'http://192.168.2.131:9001/public/files/view (45).jpeg'  ,

  'http://198.168.2.131:9001/public/files/view1 (46).jpeg'  ,
  'http://198.168.2.131:9001/public/files/view1 (131).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (48).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (49).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (50).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (51).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (52).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (53).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (54).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (55).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (56).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (57).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (58).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (59).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (60).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (61).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (62).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (63).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (64).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (65).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (66.jpeg',
  'http://198.168.2.131:9001/public/files/view1 (67).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (68).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (69).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (70).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (71).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (72).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (73).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (74).jpeg',
  
  'http://198.168.2.131:9001/public/files/view1 (75).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (76).jpeg',
  'http://198.168.2.131:9001/public/files/view1 (77).jpeg',
  ]